function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 62,
  r: 60.5,
  stroke: "#2E4F70",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9926 56.9588H51.9503C49.908 57.4694 44.2918 62.4729 42.2495 66.149C40.2072 69.8251 36.5098 69.3827 34.6377 70.2336V90.7965H78.5C81.0144 88.9415 83.3639 84.697 84.2729 79.4239C84.3614 78.9105 84.4826 78.0579 84.5558 77.5M53.9926 56.9588C54.1628 54.0656 55.6264 47.7685 60.1194 45.7262C65.7357 43.1734 71.8625 41.6417 72.8837 38.5783L75.1083 36.536L90.7536 49.8108L86.1585 55.9376L83.478 63.0856M53.9926 56.9588V76.3604C56.3753 76.7008 61.549 75.952 63.1829 70.2336V63.0856H83.478M83.478 63.0856L83.0951 64.1068C83.946 65.2981 85.1374 69.2125 85.1374 69.2125C85.1374 69.2125 85.073 71.1439 85.066 71.5M85.066 71.5H67.5096M85.066 71.5C85.0234 73.6707 84.9463 74.5213 84.5558 77.5M65.7508 77.5H84.5558M60.9064 83.5H83.0951M94 46.2748L78.3547 33M30 90.6564V70.2336",
  stroke: "#2E4F70",
  strokeWidth: 3
});

function SvgOutgoingSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingSupport);
export default __webpack_public_path__ + "static/media/OutgoingSupport.9a532c78.svg";
export { ForwardRef as ReactComponent };